
























import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ParagraphSize, IconSize, SkeletonType } from '@getaccept/lib-ui';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../types/enums/dashboard-widget-value-color';

export default defineComponent({
  name: 'DashboardWidgetSkeleton',
  props: {
    headerColor: {
      type: String as PropType<DashboardWidgetHeaderColor>,
      default: DashboardWidgetHeaderColor.Gray39,
    },
    valueColor: {
      type: String as PropType<DashboardWidgetValueColor>,
      default: DashboardWidgetValueColor.Gray96,
    },
    title: {
      type: String,
      default: '',
    },
    isSalesMode: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      ParagraphSize,
      IconSize,
      SkeletonType,
    };
  },
});
